import { ArrowUpRight, Container, Snowflake } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const SERVICES = [
  {
    id: "01",
    icon: Container,
    title: "Dry Van",
    desc: "General freight moved in enclosed dry vans — sealed and secure from dock to dock, ideal for palletized and boxed loads.",
    tags: ["General freight", "Palletized & boxed"],
    span: "lg:col-span-7",
  },
  {
    id: "02",
    icon: Snowflake,
    title: "Reefer",
    desc: "Temperature-controlled capacity for fresh and frozen goods, keeping cold-chain freight at temp from pickup to delivery.",
    tags: ["Fresh & frozen", "Temperature-controlled"],
    span: "lg:col-span-5",
  },
];

export default function Services() {
  return (
    <section id="services" className="scroll-mt-24 py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-cobalt">
            What we haul
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 max-w-3xl font-display text-[clamp(2.5rem,6vw,5rem)] font-extrabold uppercase leading-[0.92]">
            Two ways we move your freight.
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-5 lg:grid-cols-12">
          {SERVICES.map((s, i) => (
            <Reveal key={s.id} delay={0.12 * i} className={s.span}>
              <article
                data-testid={`service-card-${s.title.toLowerCase()}`}
                className="group relative h-full overflow-hidden border border-white/10 bg-panel/50 p-8 transition-all duration-300 hover:border-cobalt/70 hover:bg-panel sm:p-10"
              >
                <span className="pointer-events-none absolute right-6 top-6 font-mono text-5xl font-semibold text-white/10 transition-colors duration-300 group-hover:text-cobalt/40 sm:text-6xl">
                  {s.id}
                </span>
                <span className="grid h-14 w-14 place-items-center rounded-lg bg-cobalt/15 text-cobalt transition-colors duration-300 group-hover:bg-cobalt group-hover:text-white">
                  <s.icon className="h-7 w-7" />
                </span>
                <h3 className="mt-8 font-display text-4xl font-bold uppercase sm:text-5xl">
                  {s.title}
                </h3>
                <p className="mt-4 max-w-md text-base leading-relaxed text-white/65">
                  {s.desc}
                </p>
                <div className="mt-8 flex flex-wrap items-center gap-3">
                  {s.tags.map((t) => (
                    <span
                      key={t}
                      className="border border-white/15 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-white/60"
                    >
                      {t}
                    </span>
                  ))}
                </div>
                <ArrowUpRight className="absolute bottom-8 right-8 h-6 w-6 text-white/25 transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-cobalt" />
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <p className="mt-10 border-l-2 border-cobalt pl-5 font-mono text-xs uppercase tracking-[0.2em] text-white/55">
            Brokers welcome · Authority on file — US DOT 3452744
          </p>
        </Reveal>
      </div>
    </section>
  );
}
